module.exports = __webpack_public_path__ + "img/round2-bg.687298ca.png";